<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const { currentAccount, updateAccount } = useAccount();

const isEnabled = ref(false);

watch(
  currentAccount,
  () => {
    isEnabled.value = Boolean(
      currentAccount.value?.settings?.team_based_conversation_privacy
    );
  },
  { deep: true, immediate: true }
);

const handleToggle = async () => {
  try {
    await updateAccount(
      { team_based_conversation_privacy: isEnabled.value },
      { silent: true }
    );
    useAlert(t('GENERAL_SETTINGS.FORM.TEAM_CONVERSATION_PRIVACY.API.SUCCESS'));
  } catch (error) {
    isEnabled.value = !isEnabled.value;
    useAlert(t('GENERAL_SETTINGS.FORM.TEAM_CONVERSATION_PRIVACY.API.ERROR'));
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.TEAM_CONVERSATION_PRIVACY.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.TEAM_CONVERSATION_PRIVACY.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="handleToggle" />
      </div>
    </template>
  </SectionLayout>
</template>
